import OfertaCrud from './OfertaCrud.vue'

export default OfertaCrud

